export default __webpack_public_path__ + "static/media/DataStems_Left_Justified.99c92a37.png";